import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { RecurringInvoiceSendTypeProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const RecurringInvoiceSendType: React.FC<RecurringInvoiceSendTypeProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const getLabelClass = (status: WintSuperkollAPIModel.RecurringInvoiceSendType) => {
    switch (status) {
      case WintSuperkollAPIModel.RecurringInvoiceSendType.Auto:
        return cssExports.blueTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[recurringInvoiceService.getSendTypeText(props.type)]} className={getLabelClass(props.type)} />;
};

export default RecurringInvoiceSendType;
